import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef
} from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ITransactionLineItem } from 'src/app/EBMSuite/models/transaction.model';
import { AddTaxSetupComponent } from 'src/app/EBMSuite/modules/ebmsuite-shared/components/tax-setup/add-tax-setup/add-tax-setup.component';
import { ITax } from '../../model/organization.model';
import { OrganizationService } from '../../services/organization/organization.service';

@Component({
  selector: 'app-tax-calculator',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MultiSelectModule,
    ButtonModule,
    InputNumberModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    CardModule
  ],
  templateUrl: './tax-calculator.component.html',
  styleUrl: './tax-calculator.component.scss'
})
export class TaxCalculatorComponent implements OnInit {
  readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig);
  readonly dialogService = inject(DialogService);
  readonly organizationService = inject(OrganizationService);

  form = new FormGroup({
    quantity: new FormControl<number | null>(null),
    itemPrice: new FormControl<number | null>(null),
    itemCost: new FormControl<number | null>(null),
    taxes: new FormControl<string[]>([])
  });

  taxes = signal<ITax[]>([]);
  lineItem = signal<ITransactionLineItem | undefined>(undefined);
  currency = signal<{ code?: string; symbol?: string } | undefined>(undefined);
  conversionRate = signal<number>(1);

  taxOptions = computed(() =>
    this.taxes().map((tax) => ({
      _id: tax._id,
      name: `${tax.name} (${tax.percentage}%)`
    }))
  );

  ngOnInit(): void {
    this.#getOrganizationTaxes();
  }

  submit() {}

  openAddTaxComponent(): void {
    const ref = this.dialogService.open(AddTaxSetupComponent, {
      header: 'Add a new tax',
      height: '90%',
      width: '80%'
    });
    ref.onClose.subscribe(() => {
      this.#getOrganizationTaxes();
    });
  }

  #getOrganizationTaxes(): void {
    this.organizationService.getAllOrganizationTaxes().subscribe({
      next: (res) => {
        this.taxes.set(res.result);
        this.lineItem.set(this.config.data?.lineItem);
        this.currency.set(this.config.data?.currency);
        this.conversionRate.set(this.config.data?.conversionRate);
        this.form.get('itemPrice')?.disable();
      },
      complete: () => {
        console.log(this.lineItem(), this.currency(), this.conversionRate());
        const taxIds = this.taxes()
          .filter((tax) => {
            const taxes = this.lineItem()?.taxes || [];
            return taxes.findIndex((t) => t._id === tax._id) !== -1;
          })
          .map(({ _id }) => _id!);

        this.form.setValue({
          itemCost: this.lineItem()?.itemCost ?? 0,
          itemPrice: this.lineItem()?.itemPrice ?? 0,
          quantity: this.lineItem()?.quantity ?? 0,
          taxes: taxIds
        });
      }
    });
  }
}

/*{
    "_id": "6867a59f5250cc302cf575c2",
    "item": "67e10824d1b69b51ede36d4e",
    "name": "AUTOMATIC AIR FRESHENER REFILLS",
    "quantity": 1,
    "itemPrice": 550,
    "itemPriceFromDB": 550,
    "itemCost": 550,
    "lineTotal": 550,
    "lineCost": 550,
    "lineProfit": 0,
    "taxes": [],
    "appliedTaxes": [],
    "itemPriceWithTax": 550,
    "itemTotalTaxAmount": 0,
    "convertedLineTotal": 550,
    "convertedItemPrice": 550,
    "convertedNonDiscountLineTotal": 550,
    "nonDiscountItemTotalTaxAmount": 0,
    "nonDiscountLineTotal": 550,
    "itemType": "INVENTORYITEM"
}

*/
